// Module
var code = "<component :is=\"element\"> <slot v-if=\"isRestricted\" name=\"restricted\"><span class=\"screen-reader-only\">Restricted</span><icon name=\"lock\"></icon></slot> <slot v-else></slot> </component> ";
// Exports
export default code;